import { Component, OnInit } from '@angular/core';
import { FullscreenService } from 'src/app/shared/services/fullscreen.service';

@Component({
    selector: 'app-explore',
    templateUrl: './explore.component.html',
    styleUrls: ['./explore.component.scss'],
})
export class ExploreComponent implements OnInit {
    fullscreen = false;

    constructor(private fullScreenService: FullscreenService) {
        this.fullScreenService.getFullScreenStatus().subscribe((data) => {
            this.fullscreen = data;
        });
    }

    ngOnInit(): void {}
}
